'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-router/~/react/react.js
// module id = 133
// module chunks = 168707334958949